import type { PowerApiFilterCategory } from '@/lib/powers-data';

export type CategoryEncyclopediaEntry = {
  label: string;
  smileyCode: string;
  description: string[];
  curiosity: string;
};

export const POWER_CATEGORY_ENCYCLOPEDIA: Record<
  PowerApiFilterCategory,
  CategoryEncyclopediaEntry
> = {
  smiley: {
    label: 'Smilies',
    smileyCode: 'gline',
    description: [
      'Os Smilie Powers desbloqueiam novos smilies que podem ser utilizados nas conversas do xat. Cada power adiciona um ou mais smilies exclusivos, incluindo versões estáticas, animadas, comemorativas e colecionáveis.',
      'Se você gosta de deixar suas mensagens mais divertidas e expressivas, esta é a categoria ideal.',
    ],
    curiosity:
      'Esta categoria reúne centenas de smilies criados ao longo da história do xat.',
  },
  function: {
    label: 'Function',
    smileyCode: 'pstyle',
    description: [
      'Os Function Powers adicionam novas funcionalidades ao xat ou modificam recursos existentes. Eles podem alterar o comportamento do chat, liberar ferramentas administrativas, adicionar personalizações avançadas e disponibilizar recursos exclusivos para usuários e administradores.',
      'Grande parte das funcionalidades mais conhecidas do xat pertence a esta categoria.',
    ],
    curiosity:
      'É uma das categorias mais importantes para quem deseja aproveitar todo o potencial do xat.',
  },
  group: {
    label: 'Group Powers',
    smileyCode: 'gcontrol',
    description: [
      'Os Group Powers foram desenvolvidos para oferecer recursos voltados às comunidades do xat. Eles ajudam administradores e proprietários de chats a organizar, moderar e personalizar a experiência dos usuários.',
      'Muitos desses powers atuam diretamente no funcionamento das salas.',
    ],
    curiosity:
      'São powers voltados principalmente para gerenciamento e administração de chats.',
  },
  hug: {
    label: 'Hug',
    smileyCode: 'heartbreak',
    description: [
      'Os Hug Powers adicionam animações interativas que podem ser enviadas para outros usuários durante as conversas. Eles tornam a comunicação mais divertida e permitem demonstrar reações de maneira única.',
    ],
    curiosity: 'Diversos Hug Powers foram lançados em eventos especiais do xat.',
  },
  stickers: {
    label: 'Stickers',
    smileyCode: 'couple',
    description: [
      'Os Sticker Powers desbloqueiam coleções de stickers que podem ser enviados diretamente nas conversas. Existem centenas de temas diferentes, incluindo personagens, memes, datas comemorativas e coleções exclusivas.',
      'Cada power pode adicionar uma coleção inteira de stickers.',
    ],
    curiosity:
      'Os Sticker Powers estão entre as categorias que mais cresceram nos últimos anos.',
  },
  collection: {
    label: 'Collection',
    smileyCode: 'supersummer',
    description: [
      'Os Collection Powers fazem parte de coleções especiais lançadas pelo xat. Muitos compartilham um mesmo tema visual ou comemoram eventos específicos da comunidade.',
      'São bastante procurados por colecionadores que desejam completar suas coleções.',
    ],
    curiosity:
      'Algumas coleções possuem edições extremamente raras e limitadas.',
  },
  games: {
    label: 'Games',
    smileyCode: 'gamer',
    description: [
      'Os Game Powers permitem jogar diretamente dentro do xat. Cada power adiciona uma experiência diferente, incentivando a interação entre usuários através de jogos rápidos e divertidos.',
    ],
    curiosity:
      'Os Game Powers foram criados para tornar as salas ainda mais interativas.',
  },
  epic: {
    label: 'Epic',
    smileyCode: 'ruby',
    description: [
      'Os Epic Powers representam alguns dos powers mais exclusivos do xat. Eles costumam oferecer recursos diferenciados, efeitos únicos ou funcionalidades marcantes que fizeram parte da história da plataforma.',
      'São muito valorizados pela comunidade.',
    ],
    curiosity:
      'Nem todo power raro é um Epic, mas todo Epic foi criado para oferecer uma experiência diferenciada.',
  },
  jinx: {
    label: 'Jinx',
    smileyCode: 'jumblejinx',
    description: [
      'Os Jinx Powers permitem aplicar efeitos temporários e interativos em outros usuários do chat. Cada power possui um comportamento próprio e foi criado para tornar as conversas mais dinâmicas e imprevisíveis.',
    ],
    curiosity:
      'Cada Jinx possui um efeito exclusivo que modifica temporariamente a experiência do usuário.',
  },
};

export function getCategoryEncyclopediaEntry(
  category: string,
): CategoryEncyclopediaEntry | null {
  if (!(category in POWER_CATEGORY_ENCYCLOPEDIA)) return null;
  return POWER_CATEGORY_ENCYCLOPEDIA[category as PowerApiFilterCategory];
}

export function hasCategoryEncyclopediaEntry(category: string): boolean {
  return category in POWER_CATEGORY_ENCYCLOPEDIA;
}
